import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './app';
const root = document.getElementById('do_not_sell_container');
if (root) {
    ReactDOM.render(React.createElement(App, null), root);
}
